export function distinct<T>(array: T[], selector: ((item: T) => any) = x => x): T[] {
    const seen = new Set<any>();
    const result: T[] = [];

    for (const item of array) {
        const key = selector(item);
        if (!seen.has(key)) {
            seen.add(key);
            result.push(item);
        }
    }

    return result;
}